import React from 'react'
import RemiseForm from './components/RemiseForm'
import {ModeleRemise, modeleRemiseInitValues} from '../../../components/Models'
import {useNavigate} from 'react-router-dom'
import {createGroupeRemise} from '../../../components/requests'

const RemiseAddPage = () => {
  const navigate = useNavigate()

  const submitForm = async (fieldsToUpdate: Partial<ModeleRemise>, callback): Promise<void> => {
    const updatedData = Object.assign({...modeleRemiseInitValues}, fieldsToUpdate)
    try {
      const clientRequest = await createGroupeRemise(updatedData)
      if (clientRequest?.status === 200) {
        if (clientRequest?.data?.id !== undefined && clientRequest?.data?.id !== null) {
          navigate(`/remise/groupe/liste`, {state: {add: true}})
        }
      } else {
        navigate(`/remise/groupe/liste`, {state: {add: false}})
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback()
    }
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Créer une remise groupe client</h3>
        </div>
      </div>

      <div>
        <RemiseForm remiseId={null} data={modeleRemiseInitValues} submitForm={submitForm} />
      </div>
    </div>
  )
}

export default RemiseAddPage
